import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {Card, ListItemButton} from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CommentIcon from '@mui/icons-material/Comment';
import defaultLanguage from "i18n/defaultLanguage";
import { Trans } from 'react-i18next';

const TaskQueueCard = (form) => {
  const theme = useTheme();
  const data = form.form;

  return (
    <Card sx={{
      width:'100%',
      display: 'flex',
      border: 'solid',
      borderWidth: '0.8px',}}
    >
    <ListItemButton selected={form.selected}>
      <ListItemAvatar sx={{
        width:70,
        ml:-1}}
      >
        <ListItem
          sx={{
            width:75,
            border: 'solid',
            borderWidth: '0.8px',
            borderColor: '#9e9e9e',
            py: 0.5,
          }}
          key={data.task_id}
        >
          <ListItemText primary={data.task_type} />
        </ListItem>
      </ListItemAvatar>
      {
        data.state === 'done'? (
          <ListItemText
            sx={{textAlign: 'center'}}
            primary={
              <Trans i18nKey="toolbar.task_list_finish">{ defaultLanguage.toolbar.task_list_finish }</Trans>
            }
          />
        ): (
          <ListItemText
            sx={{textAlign: 'center'}}
            primary={
              <Trans i18nKey="toolbar.task_list_ing">{ defaultLanguage.toolbar.task_list_ing }</Trans>
            }
          />
        )
      }
      {
        data?.images?.length ? (
          <img
            width={40}
            height={40}
            sx={{ objectFit:'contain' }}
            src={data.images[0].middle}
            alt={data.images[0].middle}
            loading="lazy"
          />
        ): (
          <ListItemText
            sx={{textAlign: 'center'}}
            primary={
              <Trans i18nKey="toolbar.task_list_ing">{ defaultLanguage.toolbar.task_list_ing }</Trans>
            }
          />
        )
      }
      {data.isvip ?
            (
              <img
                width={30}
                height={17}
                src={"https://zhongbeianquan.oss-cn-beijing.aliyuncs.com/vip.png"}
                alt={"https://zhongbeianquan.oss-cn-beijing.aliyuncs.com/vip.png"}
                loading="lazy"
              />
            ):(
              <></>
            )
      }
    </ListItemButton>
    </Card>
  );
}

export default TaskQueueCard;
